module.exports = __webpack_public_path__ + "img/avatar-50.e324e35c.png";